var map = {
	"./1.jpg": 263,
	"./2.jpg": 6456,
	"./Rengoku.jpg": 9575,
	"./Rengoku1.jpg": 1482,
	"./akaza.jpg": 644,
	"./boar.jpg": 8784,
	"./img1.jpg": 1634,
	"./img10.jpg": 8256,
	"./img2.jpg": 589,
	"./img20.jpg": 8993,
	"./img3.jpg": 5024,
	"./img6.jpg": 3329,
	"./mitsuri.jpg": 8215,
	"./multi.jpg": 8293,
	"./nezuko.jpg": 4194,
	"./tanjiro.jpg": 4745,
	"./uzui.jpg": 9731,
	"./zenitsu.jpg": 6662
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8651;